module.exports = __webpack_public_path__ + "static/Rathausplatz_Luisenpassage-0a0d07b21ec2fc9cf1acf59ece8b4cbc.png";